import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <div className="relative w-full max-w-md" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-3 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-5 py-3.5 text-sm text-foreground-900 transition-colors hover:border-primary-400 cursor-pointer"
      >
        <span className="flex items-center gap-2 text-foreground-600">
          <i className="ri-list-check w-5 h-5 flex items-center justify-center text-lg text-primary-600" />
          {t("categories.dropdownPlaceholder")}
        </span>
        <i className={`ri-arrow-down-s-line w-5 h-5 flex items-center justify-center text-lg text-foreground-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>

      {open && (
        <div className="absolute left-0 right-0 top-full z-30 mt-2 max-h-80 overflow-y-auto rounded-lg border border-background-200 bg-background-50 py-2 shadow-sm">
          {categories.map((cat) => (
            <a
              key={cat.key}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              onClick={() => setOpen(false)}
              className="flex items-center justify-between gap-3 whitespace-nowrap px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100"
            >
              <span className="flex items-center gap-3">
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-100 text-foreground-600">
                  <i className={`${cat.icon} w-4 h-4 flex items-center justify-center text-base`} />
                </span>
                {t(cat.key)}
              </span>
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center text-base text-foreground-400" />
            </a>
          ))}
        </div>
      )}
    </div>
  );
}